module.exports = __webpack_public_path__ + "media/images/ic-grid-d8224365cec246f9aba4f8b94a6c8a8a.svg";